import { Box } from "@mui/material";
import { ContractStatus } from "../Contracts.types.ts";
import StatusChip from "../../common/components/statusChip/StatusChip.tsx";

export interface ContractStatusChipProps {
    status: ContractStatus | "Expired";
    value: string;
}

export function getContractStatusChipColor(status: ContractStatus | "Expired") {
    switch (status) {
        case ContractStatus.Approved:
            return "green";
        case ContractStatus.Draft:
            return "lightgreen";
        case ContractStatus.Archived:
            return "purple";
        case "Expired":
            return "red";
    }
}

function ContractStatusChip(props: ContractStatusChipProps) {
    return <StatusChip value={props.value} status={getContractStatusChipColor(props.status)} />;
}

export default ContractStatusChip;
